import type { Result } from "@pdfking/errors"

export const AutoThrow = <T>({ error, value }: Result<T>): T => {
  if (error) throw error
  return value
}
